import React from "react";
import { withRouter } from 'react-router-dom';
import AccountBanner from "../../components/AccountBanner"
import AffiliateSubaffiliateDetails from "./AffiliateSubaffiliateDetails";
import AffiliateMerchantDetails from "./AffiliateMerchantDetails";
import AffiliateCommissionDetails from "./AffiliateCommissionDetails";
import { getQueryStringParams } from "sharedUtils/navUtils"

class AffiliateDetails extends React.Component {

    state = {
        selectedCase: 1,
        affiliateId: null,
    }

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
        window.scrollTo(scrollOptions);

        this.setState({ affiliateId :this.props.match.params.id });

        const params = getQueryStringParams(window.location.search);
        const selectedCase = Math.floor(params.tab);
        console.log(params, selectedCase)
        if (selectedCase) {
            this.setState({ selectedCase });
        }
    }

    displayToggleButtons = () => {
        let options = [
            {
                name: "Subaffiliate Details",
                case: 1,
                action: () => this.handleButtonAction(1)
            },
            {
                name: "Merchant Details",
                case: 2,
                action: () => this.handleButtonAction(2)
            },
            {
                name: "Commission Details",
                case: 3,
                action: () => this.handleButtonAction(3)
            },
        ];

        return options.map((toggle, i) => {
            return (
                <button key={i}
                    className={`btn ${this.state.selectedCase === toggle.case ? "btn-primary btn-lg" : ""}`}
                    onClick={toggle.action}
                >
                    {toggle.name}
                </button>
            )
        })
    }

    handleButtonAction = selectedCase => {
        this.setState({ selectedCase });
        this.updateQueryString(selectedCase);
    }

    updateQueryString = (tab) => {
        const { history } = this.props;

        // Build the new search string with updated query parameters
        const newSearch = `?tab=${tab}`;

        // Use history.replace to update the URL without adding a new entry to the history stack
        history.replace({
            search: newSearch,
        });
    };

    getBreadCrumbList = () => {
        switch (this.state.selectedCase) {
            default: return this.breadCrumbList;
        }
    };

    render() {
        return (
            <>
                <section>
                    <AccountBanner breadCrumbList={[{ link: '/Admin', text: 'Admin' }, { link: '/Admin/AffiliateNetworks', text: 'Affiliate Networks' }, { link: '/Admin/AffiliateNetworks/' + this.state.affiliateId, text: 'Affiliate Network' }]}>
                        <h1 className="mb-4">Affiliate Details</h1>
                        <p className="mb-0">Management of affiliate network details</p>
                    </AccountBanner>
                </section>
                <section className="filter-wrapper" >
                    <div className="container">
                        <div className="row py-2 mt-0">
                            <div className="col-12 d-flex justify-content-between">
                                <div className="d-flex justify-content-around" style={{ flexWrap: "wrap" }} >
                                    {this.displayToggleButtons()}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    !!(this.state.affiliateId) ? 
                        <>
                            <section className="gray-bg full-height pt-1">
                                <AffiliateSubaffiliateDetails
                                    display={this.state.selectedCase === 1}
                                    loggedInUser={this.props.loggedInUser}
                                    apmId={this.state.affiliateId}
                                />
                                <AffiliateMerchantDetails
                                    display={this.state.selectedCase === 2}
                                    loggedInUser={this.props.loggedInUser}
                                    apmId={this.state.affiliateId}
                                />
                                <AffiliateCommissionDetails
                                    display={this.state.selectedCase === 3}
                                    loggedInUser={this.props.loggedInUser}
                                    apmId={this.state.affiliateId}
                                    deviceSize={this.props.deviceSize}
                                />
                            </section>
                        </>
                        :
                        <></>
                }
                
            </>
        )
    }
}

export default withRouter(AffiliateDetails);